import {BaseContainerModel} from '../../base-container.model';
import {bl_fi_org_label_link_RowClass} from '../../../dbschema';

export class OrganisationLabelLinkContainerModel extends BaseContainerModel {
  bl_fi_org_label_link: bl_fi_org_label_link_RowClass = new bl_fi_org_label_link_RowClass();
}
